"use client";

import dynamic from "next/dynamic";

import type { Hearing } from "@/lib/public-hearings/types";
// MapLibre + deck.gl access `window` / `document` at module load and
// can't run during SSR. `dynamic(..., { ssr: false })` is only legal
// from a "use client" boundary in the App Router; this thin host is
// that boundary. Mirrors `NetworkMapHost` in /cycling.
//
// The loading state shows an obvious pulsing-dot indicator on a paper
// substrate so a slow chunk fetch (~400 kB combined for deck.gl +
// maplibre) doesn't read as "stuck" during the seconds before the
// real map paints. The placeholder fills the parent (.mapPanel sets
// the explicit height) so the page doesn't reflow once the map mounts.
const HearingsMap = dynamic(() => import("./HearingsMap"), {
  ssr: false,
  loading: () => (
    <div className="ph-map-loading" role="status" aria-live="polite">
      <div className="ph-map-loading-chip">
        <span className="ph-map-loading-dot" aria-hidden="true" />
        <span className="cs-mono">loading map</span>
        <span className="ph-map-loading-ellipsis" aria-hidden="true">
          …
        </span>
      </div>
      <span className="ph-map-loading-hint">
        fetching map tiles &amp; markers
      </span>
    </div>
  ),
});

type Props = {
  hearings: Hearing[];
};

export function HearingsMapHost({ hearings }: Props) {
  return <HearingsMap hearings={hearings} />;
}
